module.exports = __webpack_public_path__ + "img/brand_5.b9e274bf.png";